import { FormattedMessage } from "react-intl";

import { AssetState } from "__graphql__/types";
import { Button } from "ui/Button/Button";
import { DropDown } from "ui/DropDown/DropDown";
import { Modal } from "ui/Modal/Modal";
import { BodyM, HeaderS } from "ui/Typography/Typography";

import { OUTBOUND_REASON_OPTIONS } from "../../utils/constants";

type OutboundBatteryModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onClickPrimary: () => void;
  onClickSecondary: () => void;
  setSelectedReason: (reason: AssetState) => void;
  selectedReason: null | AssetState;
};

export function OutboundBatteryModal({
  isOpen,
  onClose,
  onClickPrimary,
  onClickSecondary,
  setSelectedReason,
  selectedReason,
}: OutboundBatteryModalProps) {
  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Content maxW="295px" pt="s300" px="s200" pb="s200">
        <Modal.Body p="0">
          <HeaderS textAlign="center">
            <FormattedMessage id="pages.inventory.battery-management.modals.outbound-battery.title" />
          </HeaderS>
          <BodyM mt="s100" textAlign="center" color="grey.700">
            <FormattedMessage id="pages.inventory.battery-management.modals.outbound-battery.description" />
          </BodyM>
          <DropDown
            mt="s200"
            options={OUTBOUND_REASON_OPTIONS}
            value={selectedReason}
            onInput={(reason) => {
              setSelectedReason(reason as AssetState);
            }}
            filterMode={false}
            border="1px solid"
            borderColor="grey.800"
            borderRadius="8px"
            bgColor="white"
            titleColor="grey.800"
            w="100%"
            h="40px"
            placement="top"
          >
            <BodyM color="grey.800">
              <FormattedMessage id="pages.inventory.battery-management.modals.outbound-battery.placeholder" />
            </BodyM>
          </DropDown>
        </Modal.Body>
        <Modal.Footer p="0" mt="s200" flexDir="column" gap="s100">
          <Button
            onClick={onClickPrimary}
            variant="primary"
            size="lg"
            isFullWidth
            isDisabled={!selectedReason}
          >
            <FormattedMessage id="pages.inventory.battery-management.modals.outbound-battery.cta.primary" />
          </Button>
          <Button onClick={onClickSecondary} variant="secondary" size="lg" isFullWidth>
            <FormattedMessage id="generic.actions.cancel" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
